var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section_1"},[_c('div',{attrs:{"align":"center"}},[_c('Login',{on:{"login-success":_vm.test}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }